import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${API_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    // 403 "pending approval" - don't redirect, let the component handle it
    return Promise.reject(error);
  }
);

// Auth APIs
export const authApi = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data),
  getMe: () => api.get('/auth/me'),
  verifyEmail: (token) => api.post(`/auth/verify-email?token=${token}`),
  forgotPassword: (email) => api.post('/auth/forgot-password', { email }),
  resetPassword: (data) => api.post('/auth/reset-password', data),
};

// Submission APIs
export const submissionApi = {
  upload: (formData) => api.post('/submissions/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),
  list: (skip = 0, limit = 20) => api.get(`/submissions/list?skip=${skip}&limit=${limit}`),
  get: (id) => api.get(`/submissions/${id}`),
  getResults: (id) => api.get(`/submissions/${id}/results`),
  downloadReport: (id) => api.get(`/submissions/${id}/report`, { responseType: 'blob' }),
  emailReport: (id) => api.post(`/submissions/${id}/email-report`),
};

// Admin APIs
export const adminApi = {
  listUsers: (params) => api.get('/admin/users', { params }),
  updateUser: (id, data) => api.patch(`/admin/users/${id}`, null, { params: data }),
  resetUserPassword: (id) => api.post(`/admin/users/${id}/reset-password`),
  approveUser: (id) => api.post(`/admin/users/${id}/approve`),
  rejectUser: (id) => api.post(`/admin/users/${id}/reject`),
  getPendingCount: () => api.get('/admin/pending-count'),
  listSubmissions: (params) => api.get('/admin/submissions', { params }),
  getSettings: () => api.get('/admin/settings'),
  updateSettings: (data) => api.patch('/admin/settings', data),
  getAnalytics: () => api.get('/admin/analytics'),
  getRepositoryStats: () => api.get('/admin/repository'),
};

export default api;
